import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { MspHaloCreds } from './model';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'mspHaloCreds';

export interface State extends Status {
    data: MspHaloCreds | null;
    connected: boolean;
}

export const initialState: State = {
    data: null,
    connected: false,
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,
    on(actions.loadMspHaloCreds, (state) => ({ ...state, loading: true })),
    on(actions.loadMspHaloCredsSuccess, (state, { data, connected }) => ({
        ...state,
        data,
        connected,
        loaded: true,
        loading: false,
        error: null,
    })),
    on(actions.loadMspHaloCredsFailure, (state, { error }) => ({ ...state, error, loading: false })),

    on(actions.createMspHaloCredsSuccess, (state, { data }) => ({
        ...state,
        data,
        error: null,
        connected: true,
        loaded: true,
    })),
    on(actions.putMspHaloCredsSuccess, (state, { data }) => ({
        ...state,
        data,
        error: null,
        connected: true,
        loaded: true,
    })),
    on(actions.deleteMspHaloIntegrationSuccess, () => initialState),
);

export const selectDataAndConnection = (state: State) => ({ data: state.data, connect: state.connected });
